import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import './schedule.css';

import Nav from '../components/layout/nav';
import Search from '../components/common/search';

const Schedule = () => {
    const [schedule, setSchedule] = useState([]);

    const [showEdit, setShowEdit] = useState(false);
    const [selected, setSelected] = useState(null);

    const [form, setForm] = useState({
        designer: '',
        collection: '',
        date: '',
        time: '',
        day: '',
        location: ''
    });

    const fetchSchedule = async () => {
        const { data, error } = await supabase
            .from('schedule')
            .select('*')
            .order('id', { ascending: true });

        if (!error) setSchedule(data || []);
    };

    useEffect(() => {
        fetchSchedule();
    }, []);

    const deleteItem = async (id) => {
        const confirmDelete = window.confirm("Delete this item?");
        if (!confirmDelete) return;

        const { error } = await supabase
            .from('schedule')
            .delete()
            .eq('id', id);

        if (!error) {
            setSchedule(prev => prev.filter(item => item.id !== id));
        }
    };

    const openEdit = (item) => {
        setSelected(item);
        setForm({
            designer: item.designer,
            collection: item.collection,
            date: item.date,
            time: item.time,
            day: item.day,
            location: item.location
        });
        setShowEdit(true);
    };

    const updateSchedule = async (e) => {
        e.preventDefault();

        const { error } = await supabase
            .from('schedule')
            .update({
                designer: form.designer,
                collection: form.collection,
                date: form.date,
                time: form.time,
                day: form.day,
                location: form.location
            })
            .eq('id', selected.id);

        if (!error) {
            setShowEdit(false);
            setSelected(null);
            fetchSchedule();
        }
    };

    return (
        <div className='dashboard'>
            <Nav />

            <div className='mainarea'>

                <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>
                <div className='pagecenter'>
                    <div className='homecontainer'>

                        <section>
                             <div className='titlediv2'>
                                     <div className='titlediv'>
                                            <h1>Schedule</h1>
                                            <h2>Event timeline and runway schedule</h2>
                                        </div>
                                     
                            </div>
                            <Search search='Search Schedule' />

                            <div className='schedulediv'>

                                {schedule.map((item) => (

                                    <div key={item.id} className='schedulecard'>

                                        <div className='circle'></div>

                                        <div className='schdivv'>

                                            <div className='schTop'>
                                                <div>
                                                    <h6 className='schname'>{item.designer}</h6>
                                                    <h6 className='schcollection'>{item.collection}</h6>
                                                </div>

                                                <div style={{ display: 'flex', gap: '10px' }}>
                                                    <button
                                                        className='viewdetalsbtn'
                                                        onClick={() => openEdit(item)}
                                                    >
                                                        Edit
                                                    </button>

                                                    <button
                                                        className='viewdetalsbtn deltee'
                                                        onClick={() => deleteItem(item.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>

                                            <div className='schBottom'>
                                                <span>{item.date}</span>
                                                <span>{item.time}</span>
                                                <span>{item.day}</span>
                                                <span>{item.location}</span>
                                            </div>

                                        </div>
                                    </div>
                                ))}

                            </div>

                        </section>

                    </div>
                </div>

                {showEdit && (
                    <div className='modalOverlay'>
                        <div className='modal'>

                            <h3>Edit Schedule</h3>

                            <form onSubmit={updateSchedule}>

                                <input
                                    placeholder="Designer"
                                    value={form.designer}
                                    onChange={(e) =>
                                        setForm({ ...form, designer: e.target.value })
                                    }
                                />

                                <input
                                    placeholder="Collection"
                                    value={form.collection}
                                    onChange={(e) =>
                                        setForm({ ...form, collection: e.target.value })
                                    }
                                />

                                <input
                                    placeholder="Date"
                                    value={form.date}
                                    onChange={(e) =>
                                        setForm({ ...form, date: e.target.value })
                                    }
                                />

                                <input
                                    placeholder="Time"
                                    value={form.time}
                                    onChange={(e) =>
                                        setForm({ ...form, time: e.target.value })
                                    }
                                />

                                <input
                                    placeholder="Day"
                                    value={form.day}
                                    onChange={(e) =>
                                        setForm({ ...form, day: e.target.value })
                                    }
                                />

                                <input
                                    placeholder="Location"
                                    value={form.location}
                                    onChange={(e) =>
                                        setForm({ ...form, location: e.target.value })
                                    }
                                />

                                <div className='modalActions'>
                                    <button className='modalActionsadd' type='submit'>
                                        Save
                                    </button>

                                    <button
                                        type='button'
                                        className='modalActionscancel'
                                        onClick={() => setShowEdit(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>

                            </form>

                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default Schedule;